export enum Error_Codes {
  Not_Found = 404,
  VALIDATION_ERROR = 400,
  SERVER_ERROR = 500,
  AUTHENTICATION_ERROR = 401,
  PERMISSION_ERROR = 403,
}
